import { Component, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';

import { UiPipelineStage } from './ui-pipeline-strip.types';

@Component({
  selector: 'ui-pipeline-strip',
  standalone: true,
  imports: [MatChipsModule],
  templateUrl: './ui-pipeline-strip.component.html'
})
export class UiPipelineStripComponent {
  readonly stages = input<UiPipelineStage[]>([]);
}
